import { render } from "./MeetingsWrapper.vue?vue&type=template&id=1831c844&scoped=true"
import script from "./MeetingsWrapper.vue?vue&type=script&lang=js"
export * from "./MeetingsWrapper.vue?vue&type=script&lang=js"

import "./MeetingsWrapper.vue?vue&type=style&index=0&id=1831c844&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1831c844"]])

export default __exports__